import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SnackBarService } from '@app/services/snack-bar.service';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { ActivityService } from '@services/activity.service';
import { SidebarService } from '@services/sidebar.service';
import { ACTIVITIES_FILTER_FIELDS } from './filter-fields';
import { Breadcrumb } from '@app/models/view-models/breadcrumb';
@Component({
  selector: 'app-activities-index',
  templateUrl: './activities-index.component.html',
  styleUrls: ['./activities-index.component.scss'],
  providers: [SidebarService]
})
export class ActivitiesIndexComponent extends BaseComponent implements OnInit {
  public dataSource: any;
  public data: any;
  public displayedColumns = ['select', 'created_at', 'subject_type', 'description', 'caused_by_user', 'actions'];
  public dataLoaded = false;
  public fields: any = ACTIVITIES_FILTER_FIELDS;
  public node: Breadcrumb;
  constructor(
    public activityService: ActivityService,
    public router: Router,
    public sidebarService: SidebarService,
    public state: State,
    public snackbarService: SnackBarService,
    public dialog: MatDialog
  ) {
    super();
    this.setObjects({
      modelService: activityService,
      router,
      sidebarService,
      state,
      snackbarService,
      dialog
    });
    this.setPageVars({
      sidebar: '',
      listenForIndexUpdate: true
    });
    this.modelServiceGetAll().then(() => (this.dataLoaded = true));
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.node = {
      label: 'Activities',
      link: 'activities',
      title: 'Activities'
    };
    this.buildSettingsBreadcrumb(this.node);
  }
}
